import React, { act, useState } from "react";
import { Button } from "semantic-ui-react";
import './Crossword.css';
import CrosswordKeyboard from "./Keyboard";
import Counter from "./Counter";
import { useEffect } from "react";
const black_char = "_"

const day_1_info = {
    "crosswordData": [
        ["_", "C", "A", "R", "T", "_", "_"],
        ["_", "A", "_", "_", "_", "_", "T"],
        ["_", "N", "_", "_", "N", "_", "H"],
        ["M", "Y", "S", "T", "E", "R", "Y"],
        ["_", "O", "_", "_", "W", "_", "M"],
        ["_", "N", "_", "_", "T", "_", "E"],
        ["_", "_", "_", "_", "_", "_", "_"]
    ],
    "cluesData": {
        across: [
            { clue: "Transport is painting by the sea (4)", number: 1, row: 0, start: 1, end: 4 },
            { clue: "Problem from my tyres going bad (7)", number: 4, row: 3, start: 0, end: 6 }
        ],
        down: [
            { clue: "Any con berserk is gorge (6)", number: 1, col: 1, start: 0, end: 5 },
            { clue: "Herb heard in seconds (5)", number: 2, col: 6, start: 1, end: 5 },
            { clue: "Went mixed up for salamander (4)", number: 3, col: 4, start: 2, end: 5 },
        ]
    },
    "gridSize": { "across": 7, "down": 7 }
}

const day_2_info = {
    "crosswordData": [
        ["_", "_", "_", "_", "_", "L", "_", "_", "_", "_", "_", "_"],
        ["_", "C", "_", "_", "_", "E", "_", "_", "_", "_", "_", "_"],
        ["_", "H", "_", "_", "_", "N", "_", "_", "_", "_", "_", "_"],
        ["B", "O", "N", "N", "E", "T", "_", "E", "_", "_", "_", "_"],
        ["_", "C", "_", "_", "_", "_", "_", "A", "_", "_", "_", "_"],
        ["H", "O", "T", "C", "R", "O", "S", "S", "B", "U", "N", "S"],
        ["_", "L", "_", "_", "_", "_", "_", "T", "_", "_", "_", "_"],
        ["R", "A", "B", "B", "I", "T", "_", "E", "_", "_", "_", "_"],
        ["_", "T", "_", "_", "_", "_", "_", "R", "_", "_", "_", "_"],
        ["_", "E", "G", "G", "S", "_", "_", "_", "_", "_", "_", "_"],
    ],
    "cluesData": {
        across: [
            { clue: "Hat style not Ben [6]", number: 3, row: 3, start: 0, end: 5 },
            { clue: "Torch boss with sun, terribly baked now [3,5,4]", number: 5, row: 5, start: 0, end: 11 },
            { clue: "Religious leader at junction to go on and on [6]", number: 6, row: 7, start: 0, end: 5 },
            { clue: "Drug horses are often beaten [4]", number: 7, row: 9, start: 1, end: 4 }
        ],
        down: [
            { clue: "Advanced fast [4]", number: 1, col: 5, start: 0, end: 3 },
            { clue: "Fashion designer ingested drug and passed on confectionary [9]", number: 2, col: 1, start: 1, end: 9 },
            { clue: "More Oriental festival [6]", number: 4, col: 7, start: 3, end: 8 },
        ]
    },
    "gridSize": { "across": 12, "down": 10 }
}

const day_3_info = {
    "crosswordData": [
        ["D", "A", "I", "S", "Y", "_", "_", "_", "_", "_", "_"],
        ["_", "_", "_", "H", "_", "_", "_", "_", "_", "_", "_"],
        ["_", "_", "F", "O", "O", "L", "S", "_", "_", "_", "_"],
        ["_", "_", "_", "W", "_", "_", "_", "_", "_", "_", "_"],
        ["_", "_", "_", "E", "_", "_", "_", "_", "A", "_", "_"],
        ["_", "_", "_", "R", "_", "_", "_", "_", "P", "_", "_"],
        ["_", "_", "_", "S", "T", "G", "E", "O", "R", "G", "E"],
        ["_", "_", "_", "_", "_", "_", "_", "_", "I", "_", "_"],
        ["_", "_", "_", "_", "_", "_", "_", "_", "L", "_", "_"],
    ],
    "cluesData": {
        across: [
            { clue: "Day is puzzling for flower girl [5]", number: 1, row: 0, start: 0, end: 4 },
            { clue: "Groups of idiots often contain gooseberries [5]", number: 3, row: 2, start: 2, end: 6 },
            { clue: "Sanctimonious man's path to go green endless and crazy [2,6]", number: 5, row: 6, start: 3, end: 10 },
        ],
        down: [
            { clue: "Quiet debtors bring rain [7]", number: 2, col: 3, start: 0, end: 6 },
            { clue: "Yearly borrowing cost the Italian at the end of the financial year [5]", number: 4, col: 8, start: 4, end: 8 },
        ]
    },
    "gridSize": { "across": 11, "down": 9 }
}

const configs = [day_1_info, day_2_info, day_3_info]

function isUndefined(value) {
    return typeof value === 'undefined';
}


// Save data structure
// {
//     "puzzleProgress" = {
//         "puzzle 1": {"completed": true, "time": 120},
//         "puzzle 2": {"completed": true, "time": 120}
//     }
// }


const Crossword = () => {

    // User save data
    const loadProgress = () => {
        try {
            const data = localStorage.getItem('puzzleProgress');
            return data ? JSON.parse(data) : {};
        } catch {
            return {};
        }
    };
    const [progress, setProgress] = useState(() => loadProgress());
    useEffect(() => {
        localStorage.setItem('puzzleProgress', JSON.stringify(progress));
    }, [progress]);

    console.log(progress)

    function getDefaultIndex() {
        return configs.length - 1;
    }

    const [selectedIndex, setSelectedIndex] = React.useState(getDefaultIndex());

    const todaysConfig = configs[selectedIndex];
    if (!todaysConfig) {
        return <div>Loading...</div>;
    }

    const crosswordData = todaysConfig["crosswordData"]
    const cluesData = todaysConfig["cluesData"]
    const gridSize = todaysConfig["gridSize"];

    function findClueByPos(is_across = true, rowIndex, colIndex) {
        if (is_across) {
            return cluesData.across.find(clue =>
                clue.row === rowIndex && clue.start <= colIndex && clue.end >= colIndex
            );
        } else {
            return cluesData.down.find(clue =>
                clue.col === colIndex && clue.start <= rowIndex && clue.end >= rowIndex
            );
        }
    }

    const [grid, setGrid] = React.useState([]);

    React.useEffect(() => {
        if (!crosswordData) return;

        if (progress[selectedIndex]?.grid) {
            setGrid(progress[selectedIndex].grid)
            return
        }


        // build fresh grid
        const newGrid = crosswordData.map(row =>
            row.map(letter => ({
                value: "",
                correct: letter,
                clueNumber: null
            }))
        );

        // assign across clues
        cluesData.across.forEach(clue => {
            const { number, row, start } = clue;
            if (newGrid[row]?.[start]) {
                newGrid[row][start].clueNumber = number;
            }
        });

        // assign down clues
        cluesData.down.forEach(clue => {
            const { number, col, start } = clue;
            if (newGrid[start]?.[col]) {
                newGrid[start][col].clueNumber = number;
            }
        });

        setGrid(newGrid);

    }, [selectedIndex]);

    const [activeCell, setActiveCell] = useState({ row: null, col: null, is_row: true }); // Track the active cell
    const [clue, setClue] = useState(""); // Track the active clue

    const getNextClue = (failCounter = 0) => {
        if (activeCell.is_row) {
            console.log("checking rows")
            var starting_row = activeCell.row
            if (failCounter != 0) {
                // Started on cols so don't care what row we are in
                starting_row = -1
            }
            for (let i = activeCell.row; i < gridSize["down"]; i++) {
                for (let j = 0; j < gridSize["across"]; j++) {
                    let row = i
                    if (row != starting_row) {
                        let col = j
                        let cell = grid[row][col]
                        if (cell.value == "" && cell.correct != "_") {
                            if (findClueByPos(activeCell.is_row, row, col)) {
                                handleClick(row, col)
                                return
                            }
                        }
                    }
                }
            }
        } else {
            console.log("checking cols")
            var starting_col = activeCell.col
            if (failCounter != 0) {
                // Started on row so don't care what col we are in
                starting_col = -1
            }
            for (let j = activeCell.col; j < gridSize["across"]; j++) {
                for (let i = 0; i < gridSize["down"]; i++) {
                    let row = i
                    let col = j
                    if (col != starting_col) {
                        let cell = grid[row][col]
                        if (cell.value == "" && cell.correct != "_") {
                            if (findClueByPos(activeCell.is_row, row, col)) {
                                handleClick(row, col)
                                return
                            }
                        }
                    }
                }
            }
        }
        activeCell.is_row = !activeCell.is_row
        activeCell.row = 0
        activeCell.col = 0
        if (failCounter < 5) {
            console.log("failed")
            getNextClue(failCounter + 1)
            return
        }
        console.log("max fails reached")
    }

    const getPrevClue = (failCounter = 0) => {
        if (activeCell.is_row) {
            console.log("checking rows")
            var starting_row = activeCell.row
            if (failCounter != 0) {
                // Started on cols so don't care what row we are in
                starting_row = -1
            }
            for (let i = activeCell.row; i >= 0; i--) {
                for (let j = 0; j < gridSize["across"]; j++) {
                    let row = i
                    if (row != starting_row) {
                        let col = j
                        let cell = grid[row][col]
                        if (cell.value == "" && cell.correct != "_") {
                            if (findClueByPos(activeCell.is_row, row, col)) {
                                handleClick(row, col)
                                return
                            }
                        }
                    }
                }
            }
        } else {
            console.log("checking cols")
            var starting_col = activeCell.col
            if (failCounter != 0) {
                // Started on row so don't care what col we are in
                starting_col = -1
            }
            for (let j = activeCell.col; j >= 0; j--) {
                for (let i = 0; i < gridSize["down"]; i++) {
                    let row = i
                    let col = j
                    if (col != starting_col) {
                        let cell = grid[row][col]
                        if (cell.value == "" && cell.correct != "_") {
                            if (findClueByPos(activeCell.is_row, row, col)) {
                                handleClick(row, col)
                                return
                            }
                        }
                    }
                }
            }
        }
        activeCell.is_row = !activeCell.is_row
        activeCell.row = gridSize["down"] - 1
        activeCell.col = gridSize["across"] - 1
        if (failCounter < 5) {
            console.log("failed")
            getPrevClue(failCounter + 1)
            return
        }
        console.log("max fails reached")
    }

    const getNextPos = () => {
        if (activeCell.is_row) {
            console.log("checking row")
            for (let j = 1; j < gridSize["across"]; j++) {
                let row = activeCell.row
                let col = (activeCell.col + j) % gridSize["across"]
                let cell = grid[row][col]
                if (cell.correct != "_" && cell.isCorrect != true && cell.value == "") {
                    if (findClueByPos(activeCell.is_row, row, col)) {
                        handleClick(row, col)
                        return
                    }
                }
            }
        } else {
            console.log("checking col")
            for (let i = 1; i < gridSize["down"]; i++) {
                let col = activeCell.col
                let row = (activeCell.row + i) % gridSize["down"]
                let cell = grid[row][col]
                if (cell.correct != "_" && cell.isCorrect != true && cell.value == "") {
                    if (findClueByPos(activeCell.is_row, row, col)) {
                        handleClick(row, col)
                        return
                    }
                }
            }
        }
        getNextClue(0)
    }

    const getPrevPos = () => {
        if (activeCell.is_row) {
            console.log("moving back in row")
            let row = activeCell.row
            let col = activeCell.col - 1 >= 0 ? activeCell.col - 1 : 0
            let cell = grid[row][col]
            if (cell.correct != "_" && cell.isCorrect != true) {
                if (findClueByPos(activeCell.is_row, row, col)) {
                    handleClick(row, col)
                    return
                }
            }
        } else {
            console.log("moving back in col")
            let row = activeCell.row - 1 >= 0 ? activeCell.row - 1 : 0
            let col = activeCell.col
            let cell = grid[row][col]
            if (cell.correct != "_" && cell.isCorrect != true) {
                if (findClueByPos(activeCell.is_row, row, col)) {
                    handleClick(row, col)
                    return
                }
            }
        }
        handleClick(activeCell.row, activeCell.col)
    }

    const handleCharInput = (rowIndex, colIndex, char) => {
        const newGrid = grid.map((row, r) =>
            row.map((cell, c) => {
                if (r === rowIndex && c === colIndex) {
                    if (cell.isCorrect) return cell;

                    return {
                        ...cell,
                        value: char.toUpperCase(),
                        isCorrect: undefined
                    };
                }
                return cell;
            })
        );

        setGrid(newGrid);
        setProgress(prev => ({
            ...prev,
            [selectedIndex]: { completed: prev[selectedIndex]?.completed, time: prev[selectedIndex]?.time, grid: newGrid }
        }));
    };

    const handleKeyPress = (key) => {
        console.log(key)
        console.log(activeCell.row)
        if (activeCell.row === null || activeCell.col === null) {
            return
        }

        if (isUndefined(activeCell.row) || isUndefined(activeCell.col)) {
            console.log("this")
            return
        }
        if (grid[activeCell.row][activeCell.col].correct === black_char) {
            // Can't input on black squares
            return
        }
        if (key === "Backspace") {
            handleCharInput(activeCell.row, activeCell.col, "");
            getPrevPos()
        }
        else if (key.length === 1) { // Check if a single character is pressed
            handleCharInput(activeCell.row, activeCell.col, key);
            getNextPos()
        }
    };

    const handleClick = (rowIndex, colIndex, event) => {
        // console.log(rowIndex + " " + colIndex)
        // console.log(activeCell.row + " " + activeCell.col + " " + activeCell.is_row)
        if (activeCell.row === rowIndex && activeCell.col === colIndex) {
            // clicking on same cell twice turns it into column
            activeCell.is_row = !activeCell.is_row
        }

        if (grid[rowIndex][colIndex].isCorrect == true) {
            return
        }

        if (isUndefined(rowIndex) || isUndefined(colIndex)) {
            console.error("Missing index " + rowIndex + " " + colIndex)
            return
        }
        // console.log(activeCell.is_row)
        if (grid[rowIndex][colIndex].correct === black_char) {
            return
        }
        setActiveCell({ row: rowIndex, col: colIndex, is_row: activeCell.is_row }); // Set the clicked cell as active
        updateClue(rowIndex, colIndex);

        var target = document.getElementById(`cell-${rowIndex}-${colIndex}`)
        if (isUndefined(event) || event.target != target) {
            target.focus();
            target.click();
        }
    };

    const [currentTime, setCurrentTime] = useState(0);
    const [finishTime, setFinishTime] = useState(0);

    const url = window.location.href; // current page URL

    const copyLink = () => {
        const text = "I solved cryptick #" + (selectedIndex + 1) + " in " + finishTime + "s \n" + url
        navigator.clipboard.writeText(text)
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    }



    const updateClue = (rowIndex, colIndex) => {
        let clueToShow = "";
        let across_clue = findClueByPos(true, rowIndex, colIndex)
        let down_clue = findClueByPos(false, rowIndex, colIndex)
        if (activeCell.is_row) {
            if (across_clue) {
                clueToShow = `${across_clue.number}: ${across_clue.clue}`;
            } else {
                clueToShow = `${down_clue.number}: ${down_clue.clue}`;
                setActiveCell({ row: rowIndex, col: colIndex, is_row: !activeCell.is_row });
            }
        } else {
            if (down_clue) {
                clueToShow = `${down_clue.number}: ${down_clue.clue}`;
            } else {
                clueToShow = `${across_clue.number}: ${across_clue.clue}`;
                setActiveCell({ row: rowIndex, col: colIndex, is_row: !activeCell.is_row });
            }
        }
        setClue(clueToShow); // Set the clue for the clicked cell
    };


    const checkPuzzle = () => {
        setActiveCell({ row: -1, col: -1, is_row: activeCell.is_row });
        const newGrid = grid.map(row =>
            row.map(cell => ({
                ...cell,
                isCorrect: cell.value === cell.correct
            }))
        );
        setGrid(newGrid);
        const allCorrect = newGrid.every(row => row.every(cell => cell.correct === "_" || cell.value === cell.correct));
        if (allCorrect && finishTime == 0) {
            if (!progress[selectedIndex]?.completed) {
                setFinishTime(currentTime)
                setProgress(prev => ({
                    ...prev,
                    [selectedIndex]: { completed: true, time: currentTime, grid: newGrid }
                }));
            } else {
                setFinishTime(progress[selectedIndex]?.time)
            }
        }
    };

    const getClassName = (cell, rowIndex, colIndex) => {
        // console.log(activeCell.row + " " + activeCell.col)
        if (cell.correct === black_char) {
            return 'empty'
        } else if (cell.isCorrect == true) {
            return 'correct'
        } else if (activeCell.row === rowIndex && activeCell.col === colIndex) {
            if (cell.isCorrect == false) {
                return 'incorrect active'
            }
            return 'active'
        }
        else if ((findClueByPos(activeCell.is_row, rowIndex, colIndex) === findClueByPos(activeCell.is_row, activeCell.row, activeCell.col)) && findClueByPos(activeCell.is_row, rowIndex, colIndex) != undefined) {
            if (cell.isCorrect == false) {
                return 'incorrect group'
            }
            return 'group'
        } else if (cell.isCorrect === undefined) {
            return ''
        } else {
            return 'incorrect'
        }
    }

    useEffect(() => {
        setFinishTime(0);
    }, [selectedIndex]);

    return (
        <div style={{ textAlign: 'center' }}>
            <div>
                <h2>{finishTime === 0 ? currentTime : finishTime}s</h2>
                <Counter onTick={setCurrentTime} />
            </div>
            <div>
                <select
                    value={selectedIndex}
                    onChange={(e) => setSelectedIndex(Number(e.target.value))}
                >
                    {configs.map((_, index) => (
                        <option key={index} value={index}>
                            Day {index + 1} {progress[index]?.time}{progress[index] ? "s" : ""}
                        </option>
                    ))}
                </select>
            </div>
            <br />
            <div className="crossword-grid">
                {grid.map((row, rowIndex) => (
                    <div className="crossword-row" key={rowIndex}>
                        {row.map((cell, colIndex) => (
                            <div
                                key={colIndex}
                                className={`crossword-input ${getClassName(cell, rowIndex, colIndex)}`}
                                onClick={(e) => {
                                    handleClick(rowIndex, colIndex, e);
                                }}
                                tabIndex={0}
                                onKeyDown={(e) => handleKeyPress(e.key)}
                                id={`cell-${rowIndex}-${colIndex}`}
                            >
                                {cell.clueNumber && (
                                    <span className="clue-number">
                                        {cell.clueNumber}
                                    </span>
                                )}
                                {cell.value}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            <br />
            <div className="clue-box" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button className="check-button" onClick={() => getPrevClue(0)}>&lt;</Button>
                <div className="clue" style={{ paddingLeft: '16px', paddingRight: '16px', fontSize: '18px' }}>{clue || "Click a cell to see the clue"}</div>
                <Button className="check-button" onClick={() => getNextClue(0)}>&gt;</Button>
            </div>
            <br></br>
            <CrosswordKeyboard onKeyPress={handleKeyPress}></CrosswordKeyboard>
            <br />
            <Button className="check-button" onClick={checkPuzzle}>Check Puzzle</Button>
            <br></br>
            <br></br>
            <br></br>
            {finishTime !== 0 &&
                <div>
                    {"Solved in " + finishTime + "s!"}
                    <br></br>
                    <br></br>
                    < button class="share-btn" onClick={copyLink}> <svg class="icon" viewBox="0 0 24 24"> <path d="M18 16a3 3 0 0 0-2.24 1.03L8.91 13.7a3.07 3.07 0 0 0 0-3.39l6.85-3.33A3 3 0 1 0 15 5a3 3 0 0 0 .09.7L8.24 9.03a3 3 0 1 0 0 5.94l6.85 3.33A3 3 0 1 0 18 16z" /> </svg> Share </button>
                </div>
            }

        </div >
    );
};

export default Crossword;
